export default "__VITE_ASSET__B7Ew5j9I__"